// extracted by mini-css-extract-plugin
module.exports = {"map-container":"chloropleth_map-container__1doNT","locale-controls":"chloropleth_locale-controls__116JF"};